module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-blue.d5ccf35b.svg";